import {createSelector} from '@reduxjs/toolkit';

const selectHighlights = (state) => state.highlights;

export const selectHighlightsTargetTag = (state) => selectHighlights(state)?.targetTag ?? null;

export const selectHighlightsMessageId = (state) => selectHighlights(state)?.messageId ?? null;

export const selectHighlightsNavigation = createSelector(
    [selectHighlightsTargetTag, selectHighlightsMessageId],
    (targetTag, messageId) => ({
        targetTag,
        messageId,
    })
);
